import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import encrypt from '../runtime/encrypt.js';
import decrypt from '../runtime/decrypt.js';
import generateIv from './iv.js';
import { encode as base64url } from '../runtime/base64url.js';
export function wrap(_x, _x2, _x3, _x4) {
  return _wrap.apply(this, arguments);
}

function _wrap() {
  _wrap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(alg, key, cek, iv) {
    var jweAlgorithm, _yield$encrypt, encryptedKey, tag;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            jweAlgorithm = alg.slice(0, 7);
            iv || (iv = generateIv(jweAlgorithm));
            _context.next = 4;
            return encrypt(jweAlgorithm, cek, key, iv, new Uint8Array(0));

          case 4:
            _yield$encrypt = _context.sent;
            encryptedKey = _yield$encrypt.ciphertext;
            tag = _yield$encrypt.tag;
            return _context.abrupt("return", {
              encryptedKey: encryptedKey,
              iv: base64url(iv),
              tag: base64url(tag)
            });

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _wrap.apply(this, arguments);
}

export function unwrap(_x5, _x6, _x7, _x8, _x9) {
  return _unwrap.apply(this, arguments);
}

function _unwrap() {
  _unwrap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(alg, key, encryptedKey, iv, tag) {
    var jweAlgorithm;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            jweAlgorithm = alg.slice(0, 7);
            return _context2.abrupt("return", decrypt(jweAlgorithm, key, encryptedKey, iv, tag, new Uint8Array(0)));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _unwrap.apply(this, arguments);
}